import Table from './Table';
import Table2 from './Table2';
import Tree from './Tree';
import TreeD3 from './TreeD3';
import List from './List';
import RadioBox from './RadioBox';
import SelectBox from './SelectBox';
import Slider from './Slider';
import SearchAutocomplete from './SearchAutocomplete';
import Tab from './Tab';
import SplitLayout from './SplitLayout';
import Yasgui from './Yasgui';
import BBMap from './bb/BBMap';
import BBTable from './bb/BBTable';
import BBTreeTable from './bb/BBTreeTable';
import BBYasgui from './bb/BBYasgui';
import BBYasr from './bb/BBYasr';
import BBYasguiNotebook from './bb/BBYasguiNotebook';
import BBNotebook from './bb/BBNotebook';
import BBKGApiVizWidget from './bb/BBKGApiVizWidget';  
import BBVoyager from './bb/BBVoyager';  
// import Search from './Search';

let widgetDefinitions = [
  {
    name: 'SplitLayout',
    component: SplitLayout,
    label: 'Split Layout',
    variables: [
      {
        name: 'direction',
        type: 'select',
        label: 'Direction',
        options: [
          {
            label: 'Rijen',
            value: 'column'
          },
          {
            label: 'Kolommen',
            value: 'row'
          }
        ]
      },
      {
        name: 'areaSizes',
        type: 'array',
        // label: 'Column widths or row heights (separated by commas). Value can be a number (which will be set as flex values/verhoudingswaarden) or a px/% value',
        label:
          "Kolom Breedte of Rij hoogte, gescheiden door comma's. Waarden kunnen gegeven worden in pixels, percentage of getallen. Een getal is verhoudingsgetal ten opzichte van de andere Rijen/Kolommen. (Een voorbeeld: 130px,1,10%)"
      }
    ]
  },
  {
    name: 'Tab',
    component: Tab,
    label: 'Tab Layout',
    variables: [
      {
        name: 'tabs',
        type: 'array',
        label: 'Tabs'
      },
      {
        name: 'tabSelectionSubscription',
        type: 'text',
        label: 'Variabele to listen to for tab selection'
      },
      {
        name: 'icons',
        type: 'array',
        label: 'fa icon names when no icon is defined. '
      }
    ],
  },
  {
    name: 'List',
    component: List,
    label: 'List widget',
    variables: [
      {
        name: 'query',
        type: 'yasgui',
        label: 'to fill list'
      },
      {
        name: 'publishVariable',
        type: 'text',
        label: 'Variabele in which list item URI is published, when list item is clicked.'
      },
      {
        name: 'subscribeVariable',
        type: 'text',
        label: 'Published variabele on which to listen to to define list item selection.'
      }
    ]
  },
  {
    name: 'SelectBox',
    component: SelectBox,
    label: 'Select box widget',
    variables: [
      {
        name: 'query',
        type: 'yasgui',
        label: 'To fill select box items'
      },
      {
        name: 'publishVariable',
        type: 'text',
        label: 'Variabele in which the URI of the selected item is published.'
      },
      {
        name: 'label',
        type: 'text',
        label: 'Label'
      }
    ]
  },
  {
    name: 'Slider',
    component: Slider,
    label: 'Slider widget',
    variables: [
      {
        name: 'query',
        type: 'yasgui',
        label: 'Sparql query to define min max values of the slider'
      },
      {
        name: 'publishVariable',
        type: 'text',
        label: 'Variabele in which the value of the slider is published.'
      },
      {
        name: 'label',
        type: 'text',
        label: 'Label'
      }
    ]
  },
  {
    name: 'RadioBox',
    component: RadioBox,
    label: 'Radio box widget',
    variables: [
      {
        name: 'publishVariable',
        type: 'text',
        label: 'Variabele in which the URI of the selected radio box is published.'
      },
      {
        name: 'label',
        type: 'text',
        label: 'Label'
      },
      {
        name: 'options',
        type: 'text',
        label: 'Options defined by a comma separated list of value/label pairs',
      },
    ]
  },
  {
    name: 'SearchAutocomplete',
    component: SearchAutocomplete,
    label: 'Search autocomplete widget',
    variables: [
      {
        name: 'query',
        type: 'yasgui',
        label: 'Query to fill search results.'
      },
      {
        name: 'publishVariable',
        type: 'text',
        label: 'Variabele in which searchterm is published.'
      },
      {
        name: 'alignItems',
        type: 'select',
        label: 'Uitlijning',
        options: [
          {
            label: 'Stretch',
            value: 'stretch'
          },
          {
            label: 'Start',
            value: 'flex-start'
          },
          {
            label: 'Center',
            value: 'center'
          },
          {
            label: 'End',
            value: 'flex-end'
          }
        ]
      },
      {
        name: 'cssEscape',
        type: 'text',
        label: 'JSON object of CSS statements'
      },
    ]
  },
  {
    name: 'Tree',
    component: Tree,
    label: 'Tree widget',
    variables: [
      {
        name: 'query',
        type: 'yasgui',
        label:
          'Query to fill tree. First item should be the object label, the second the object URI, the third the parent URI. optional you can use icon, icon2 and icon3 variables for fa-fa icons'
      },
      {
        name: 'publishVariable',
        type: 'text',
        label: 'Variabele in which tree item URI is published, when tree item is clicked.'
      },
      {
        name: 'subscribeVariable',
        type: 'text',
        label: 'Publish variabele on which to listen to to define tree item selection.'
      },
      {
        name: 'rootLabel',
        type: 'text',
        label: 'Label of the root of the tree. Leave empty for no root.'
      },
      {
        name: 'defaultIcon',
        type: 'text',
        label: 'fa icon name when no icon is defined. '
      }
      ,
      {
        name: 'aggregate',
        type: 'boolean',
        label: 'Aggregate the results based upon parent and child uri '
      },
      {
        name: 'shouldNonSelectedSubTreeClose',
        type: 'boolean',
        label:
          'Should a subtree that does not contain selection fold on new selection.'
      }
    ]
  },
  {
    name: 'TreeD3',
    component: TreeD3,
    label: 'TreeD3 widget',
    variables: [
      {
        name: 'query',
        type: 'yasgui',
        label: 'to fill tree'
      },
      {
        name: 'publishVariableOnTreeItemClick',
        type: 'text',
        label: 'Publish/subscribe variabele in which tree item URI is published, when tree item is clicked.'
      },
      {
        name: 'subscribeVariableForTreeItemSelection',
        type: 'text',
        label: 'Publish/subscribe variabele on which to listen to define tree item selection.'
      },
      {
        name: 'subscribeVariableForTreeConnectionHighlight',
        type: 'text',
        label: 'Publish/subscribe variabele on which to listen to define which tree connections to highlight'
      },
      {
        name: 'subscribeVariableForFilter',
        type: 'text',
        label: 'Publish/subscribe variabele on which to listen to define which tree items should be filtered out'
      },
      {
        name: 'rootLabel',
        type: 'text',
        label: 'Label of the root of the tree. Leave empty for no root.'
      },
      {
        name: 'treeType',
        type: 'select',
        label: 'Soort boom',
        options: [
          {
            label: 'Horizontaal',
            value: 'horizontal'
          },
          {
            label: 'Radiaal',
            value: 'radial'
          }
        ]
      },
    ]
  },
  {
    name: 'Table',
    component: Table,
    label: 'Table widget',
    variables: [
      {
        name: 'query',
        type: 'yasgui',
        label: 'Query to fill table. If table item should be a link, than the you should add a property with the same name with suffix "URI", eg: ?object ?objectURI.'
      },
      {
        name: 'publishVariable',
        type: 'text',
        label: 'Variabele in which tree item URI is published, when a link in the table  is clicked.'
      },
      {
        name: 'title',
        type: 'text',
        label: 'Titel boven de tabel'
      },
      {
        name: 'renderEmpty',
        type: 'boolean',
        label: 'render an empty table'
      },
      ,
      {
        name: 'aggregateResultsByFirstParameter',
        type: 'boolean',
        label: 'aggregate sparql results by the first parameter'
      }

      
    ]
  },
  {
    name: 'Table2',
    component: Table2,
    label: 'Table2 widget',
    variables: [
      {
        name: 'query',
        type: 'yasgui',
        label: 'Query to fill table. If table item should be a link, than the you should add a property with the same name with suffix "URI", eg: ?object ?objectURI.'
      },
      {
        name: 'publishVariable',
        type: 'text',
        label:
          'Variabele in which tree item URI is published, when a link in the table  is clicked.'
      },
      
      {
        name: 'renderEmpty',
        type: 'boolean',
        label: 'render an empty table'
      },
      {
        name: 'isFirstItemBold',
        type: 'boolean',
        label:
          'First item bold'
      },
      {
        name: 'title',
        type: 'text',
        label: 'Titel boven de tabel'
      },
      {
        name: 'onClick',
        type: 'javascript',
        label:
          'Code that runs before link click event.'
      }
    ]
  },
  {
    name: 'Yasgui',
    component: Yasgui,
    label: 'Yasgui widget'
  },
  {
    name: 'BBTable',
    component: BBTable,
    label: 'BB Table widget',
    variables: [
      {
        name: 'query',
        type: 'yasgui',
        label: 'to fill the map. Use ?uri and ?geometry for WKT strings. Optionally use ?color for automatic coloring '
      },
      
      {
        name: 'subscribeVariable',
        type: 'text',
        label: 'Published uri variabele on which to listen to define selection.'
      }
    ]
  },
  {
    name: 'BBTreeTable',
    component: BBTreeTable,
    label: 'BB Tree Table widget',
    variables: [
      {
        name: 'query',
        type: 'yasgui',
        label: 'to fill the map. Use ?uri and ?geometry for WKT strings. Optionally use ?color for automatic coloring '
      },
      {
        name: 'publishVariable',
        type: 'text',
        label: 'Variabele in which an item URI is published, when a feature in the map is clicked.'
      },
      {
        name: 'subscribeVariable',
        type: 'text',
        label: 'Published uri variabele on which to listen to define selection.'
      }
    ]
    
  },
  {
    name: 'BBMap',
    component: BBMap,
    label: 'Leaflet map',
    variables: [
      {
        name: 'query',
        type: 'yasgui',
        label: 'to fill the map. Use ?uri and ?geometry for WKT strings. Optionally use ?color for automatic coloring '
      },
      {
        name: 'publishVariable',
        type: 'text',
        label: 'Variabele in which an item URI is published, when a feature in the map is clicked.'
      },
      {
        name: 'subscribeVariable',
        type: 'text',
        label: 'Published uri variabele on which to listen to define selection.'
      }
    ]
  },
  {
    name: 'BBYasgui',
    component: BBYasgui,
    label: 'BB YasGUI',
    variables: [
      
    ]
  }
  ,
  {
    name: 'BBVoyager',
    component: BBVoyager,
    label: 'BB Voyager',
    variables: [
      {
        name: 'query',
        type: 'yasgui',
        label: 'to fill the diagram. ( ?domainName ?rangeName ?propname)'
      },
      {
        name:'height',
        type:'string',
        label:'optional css string for the height value'
      }
      
    ]
  }
  ,
  {
    name: 'BBYasguiNotebook',
    component: BBYasguiNotebook,
    label: 'BB YasGUINotebook',
    variables: [
      
    ]
  },
  {
    name: 'BBNotebook',
    component: BBNotebook,
    label: 'BB Notebook',
    variables: [
      
    ]
  },
  {
    name: 'BBYasr',
    component: BBYasr,
    label: 'BB Yasr',
    variables: [
      {
        name: 'query',
        type: 'yasgui',
        label: 'to fill yasr chart. '
      },
      {
        name: 'title',
        type: 'text',
        label: 'title of the chart '
      },
      {
        name: 'chartType',
        type: 'select',
        label: 'type of the chart',
        options: [
          {
            label: 'Pie chart',
            value: 'PieChart'
          },
          {
            label: 'ColumnChart',
            value: 'ColumnChart'
          },
          {
            label: 'Bar chart',
            value: 'BarChart'
          },
          {
            label: 'Line chart',
            value: 'LineChart'
          },
          {
            label: 'Donut (nog niet aanwezig)',
            value: 'Donut'
          },
          {
            label: 'Gauge',
            value: 'Gauge'
          }
        ]
      },
      {
        name: 'ddd',
        type: 'boolean',
        label: '3D',
      }
    ]
  },
  {
    name: 'BBKGApiVizWidget',
    component: BBKGApiVizWidget,
    label: 'BBKGApiVizWidget',
    variables: [
     {
       name: 'query',
       type: 'yasgui',
       label: 'just to start. '
      }
    ]
  }
];



export default widgetDefinitions;
